import { render, staticRenderFns } from "./judgeDetail.vue?vue&type=template&id=14d1cc46&scoped=true&"
import script from "./judgeDetail.vue?vue&type=script&lang=js&"
export * from "./judgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./judgeDetail.vue?vue&type=style&index=0&id=14d1cc46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d1cc46",
  null
  
)

export default component.exports